import axios, { AxiosError } from 'axios'
import config from 'config'
import ApplicationProgress from 'state/enums/ApplicationProgress'
import ApplicationStatus from 'state/enums/ApplicationStatus'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'

export type ApplicationSubmissionStatus = {
    id: number
    uuid: string
    status: `${ApplicationStatus}`
    progress: `${ApplicationProgress}`
    is_decision_pending: boolean
    is_submission_in_invalid_state: boolean
}

/**
 * Get an application submission status by its identifier.
 *
 * @param  {number | string} [uuid] Application UUID.
 * @return {Object} Application data.
 */
export default async function getApplicationSubmissionStatus(
    uuid: string,
): Promise<ApplicationSubmissionStatus> {
    try {
        if (!uuid) {
            throw new Error('Application UUID cannot be empty')
        }

        const { data } = await axios.get(
            `${config.API_BASE_URL}/api/v3/client-application/${uuid}/submission-status/`,
            {
                withCredentials: true,
            },
        )

        return data as ApplicationSubmissionStatus
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to get application submission status: ${axiosError.message}`,
            axiosError,
            { applicationUuid: uuid },
        )

        throw axiosError
    }
}
